const ROUTES = {
  tutorAccountStatement: '/estado_cuenta_menores',
  pagos: '/pagos',
  pagoqr: '/pagoqr',
  registroqr: '/registroqr',
  landing: '/',
};

export default { ROUTES };
